import React from 'react';

import Thumb from '../img/blogs/javascript.jpg';

const SomeJavaScriptInterviewTasks = {
    id: 21, permalink: "some-javascript-interview-tasks", thumb: Thumb, postBy: "Wasek Bellah", postDate: "May 16, 2020", categories: "JavaScript", title: "Some JavaScript Interview Tasks", shortDesc: "When you want a Web Developer job, In the Interview you will be faced with JavaScript related tasks. So, here are some most Interview Tasks about JavaScript.", fullDesc: <>
        <p>When you want a <strong>Web Developer</strong> job, In the <strong>Interview</strong> you will be faced with <strong>JavaScript</strong> related tasks. So, here are some most <strong>Interview Tasks</strong> about <strong>JavaScript</strong>, that can help you in the <strong>Interview</strong>.</p>


        <h2>Reverse each word in the sentence</h2>

        <h3>Answer:</h3>
        <p>I will first <strong>reverse words</strong> and then <strong>reverse the string</strong>.</p>

        <pre className="code">
            const reverseInPlace = str => str.split(' ').reverse().join(' ').split('').reverse().join(''); <br />
            console.log(reverseInPlace("I am Wasek Bellah"));
        </pre>
        <p><strong>Expected output:</strong> <code className="output">I ma kesaW halleB</code></p>


        <h2>Implement array enqueue and dequeue methods. In the dequeue method store dequeue items in another array.</h2>

        <h3>Answer:</h3>
        <p><strong>Enqueue</strong> means to add an element, <strong>dequeue</strong> means to remove an element.</p>

        <pre className="code">
            const enqueue = (arr, item) => arr.push(item); <br /><br />

            const dequeue = (dequeueArr, dequeueArrStore) => &#123; <br />
                &nbsp; if (dequeueArrStore.length &lt;= 0) &#123; <br />
                    &nbsp;   while (dequeueArr.length &gt; 0) &#123; <br />
                        &nbsp;     let elementToOutput = dequeueArr.pop(); <br />
                        &nbsp;     dequeueArrStore.push(elementToOutput); <br />
                    &nbsp;   &#125; <br />
                &nbsp; &#125; <br />
                &nbsp; return dequeueArrStore.reverse(); <br />
            &#125;
        </pre>

        <pre className="code">
            let firstArray = []; <br /><br />

            enqueue(firstArray, "Hi"); <br />
            enqueue(firstArray, "Hello"); <br />
            enqueue(firstArray, "World"); <br />
            console.log(firstArray);
        </pre>
        <p><strong>Expected output:</strong> <code className="output">[ 'Hi', 'Hello', 'World' ]</code></p>


        <pre className="code">
            let firstArrayStore = []; <br /><br />

            dequeue(firstArray, firstArrayStore); <br />
            console.log(firstArray); <br />
            console.log(firstArrayStore); <br />
        </pre>
        <p><strong>Expected output:</strong> <code className="output">[]</code> and <code className="output">[ 'Hi', 'Hello', 'World' ]</code></p>

        <p>After <strong>dequeue</strong>, <code>firstArray</code> is empty. And stored to <code>firstArrayStore</code>.</p>


        <h2>Write a "<code>multiple</code>" function which will properly when invoked as below syntax.</h2>
        <pre className="code">
            multiple(2)(4)(6);
        </pre>

        <h3>Answer:</h3>
        <pre className="code">
            const multiple = a => &#123; <br />
                &nbsp; return b => &#123; <br />
                    &nbsp;   return c => &#123; <br />
                        &nbsp;     return a * b * c; <br />
                    &nbsp;   &#125; <br />
                &nbsp; &#125; <br />
            &#125; <br />
            console.log(multiple(2)(4)(6));
        </pre>
        <p><strong>Expected output:</strong> <code className="output">48</code></p>


        <h2>Empty an array and store that array data in another array.</h2>

        <h3>Answer:</h3>
        <p><em>There are several ways to empty an <strong>array</strong>. One of them:</em></p>
        <pre className="code">
            let ages = [21, 45, 32, 38, 16, 41, 29, 27]; <br />
            let storeAges = ages; <br />
            ages = []; <br /><br />

            console.log(ages); <br />
            console.log(storeAges); <br />
        </pre>
        <p><strong>Expected output:</strong> <code className="output">[]</code> and <code className="output">[ 21, 45, 32, 38, 16, 41, 29, 27 ]</code></p>


        <h2>Check the number is an integer or not?</h2>

        <h3>Answer: </h3>
        <p>If there is any remainder left when divided by <code>1</code>, that is not an <strong>Integer</strong>. If no remainder left that is an <strong>Integer</strong>.</p>
        <pre className="code">
            const isInt = num => num % 1 === 0; <br /><br />

            console.log(isInt(6)); <br />
            console.log(isInt(6.5)); <br />
        </pre>
        <p><strong>Expected output:</strong> <code className="output">true</code> and <code className="output">false</code></p>


        <h2>What is a callback function?</h2>

        <h3>Answer:</h3>
        <p>A <strong>callback function</strong> is a <strong>function</strong> passed into another <strong>function</strong> as an <strong>argument</strong>, which is then <strong>invoked</strong> inside the outer <strong>function</strong> to complete some kind of action.</p>

        <pre className="code">
            const modifyArray = (arr, callback) => &#123; <br />
                &nbsp; arr.unshift(0); <br />
                &nbsp; callback(); <br />
            &#125; <br /><br />

            let number = [1, 2, 3, 4, 5]; <br />
            modifyArray(number, () => console.log("Number array has been modified", number)); <br />
        </pre>
        <p><strong>Expected output:</strong> <code className="output">Number array has been modified [ 0, 1, 2, 3, 4, 5 ]</code></p>


        <h2>Create an <strong>array</strong> duplicate <strong>function</strong>. i.e. <code>[1, 2, 3, 4, 5]</code> to  <code>[1, 2, 3, 4, 5, 1, 2, 3, 4, 5]</code> </h2>

        <h3>Answer: </h3>
        <pre className="code">
            const duplicateArr = arr => arr.concat(arr); <br /><br />

            let number = [1, 2, 3, 4, 5] <br />
            console.log(duplicateArr(number)); <br />
        </pre>
        <p><strong>Expected output:</strong> <code className="output">[1, 2, 3, 4, 5, 1, 2, 3, 4, 5]</code></p>


        <h2>Given two strings, if they are anagrams of one another, return <code>true</code>.</h2>

        <h3>Answer: </h3>
        <pre className="code">
            const isAnagram = (firstStr, secondStr) => &#123; <br />
                &nbsp; let a = firstStr.toLowerCase(); <br />
                &nbsp; let b = secondStr.toLowerCase(); <br /><br />

                &nbsp; newA = a.split("").sort().join(""); <br />
                &nbsp; newB = b.split("").sort().join(""); <br />
                &nbsp; return newA === newB; <br />
            &#125; <br /><br />

            console.log(isAnagram("Mary", "Army")); <br />
            console.log(isAnagram("Hello", "World"));
        </pre>
        <p><strong>Expected output:</strong> <code className="output">true</code> and <code className="output">false</code></p>
    </>
};
export default SomeJavaScriptInterviewTasks;